import React, { Component } from "react";
import "./App.css";
import env from './env.json';
import FruityPebblesOverlay from "./FruityPebblesOverlay";

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            books: [],
            movies: [],
            shows: [],
            podcasts: [],
            recipes: [],
            crochet: [],
            music: [],
            concerts: [],
            loading: true,
            error: null,
            mode: "books",
            hasEasterEggBeenClicked: false
        };
    }

    componentDidMount() {
        Promise.all([
            fetch(`${env.BACKEND_URL}/api/books`).then(function (res) {
                return res.json();
            }),
            fetch(`${env.BACKEND_URL}/api/movies`).then(function (res) {
                return res.json();
            }),
            fetch(`${env.BACKEND_URL}/api/shows`).then(function (res) {
                return res.json();
            }),
            fetch(`${env.BACKEND_URL}/api/podcasts`).then(res => res.json()),
            fetch(`${env.BACKEND_URL}/api/recipes`).then(res => res.json()),
            fetch(`${env.BACKEND_URL}/api/crochet`).then(res => res.json()),
            fetch(`${env.BACKEND_URL}/api/music`).then(res => res.json()),
            fetch(`${env.BACKEND_URL}/api/concerts`).then(res => res.json())
        ])
            .then(
                function (data) {
                    this.setState({
                        books: Array.isArray(data[0]) ? data[0] : [],
                        movies: Array.isArray(data[1]) ? data[1] : [],
                        shows: Array.isArray(data[2]) ? data[2] : [],
                        podcasts: Array.isArray(data[3]) ? data[3] : [],
                        recipes: Array.isArray(data[4]) ? data[4] : [],
                        crochet: Array.isArray(data[5]) ? data[5] : [],
                        music: Array.isArray(data[6]) ? data[6] : [],
                        concerts: Array.isArray(data[7]) ? data[7] : [],
                        loading: false
                    });
                }.bind(this)
            )
            .catch(
                function (error) {
                    this.setState({
                        error: error.message,
                        loading: false
                    });
                }.bind(this)
            );
    }

    setMode(mode) {
        this.setState({ mode: mode });
    }

    renderCards(items, type) {
        return items.map(function (item, index) {
            const title = item.title || "Untitled";

            let subtitle = item.subtitle || "";

            if (type === "BOOK") {
                subtitle = item.author || "Unknown author";
            }

            if (type === "MOVIE") {
                subtitle = `${item.releaseDate || "Unknown"} · ⭐ ${item.rating || "N/A"}`;
            }

            if (type === "SHOW") {
                subtitle = `${item.firstAirDate || "Unknown"} · ⭐ ${item.rating || "N/A"}`;
            }

            const description =
                item.description ||
                item.overview ||
                "No description available.";

            let link = item.link || item.buyLink || null;

            if (type === "BOOK") {
                link = `https://www.goodreads.com/search?q=${encodeURIComponent(title)}`;
            }

            return (
                <div className="orbit-card" key={`${type}-${item.rank || index}`}>
                    <div className="glitch-rank">
                        {index === 9 ? 10 : `0${index + 1}`}
                    </div>

                    <div className="holo-cover-wrap">
                        {item.image ? (
                            <img className="holo-cover" src={item.image} alt={title} />
                        ) : (
                            <div className="holo-cover missing">
                            <span className="placeholder-icon">
                                {type === "CROCHET" ? "🧶" : "✦"}
                            </span>
                                <span>{type}</span>
                            </div>
                        )}
                    </div>

                    <div className="info">
                        <p className="type">{type}</p>
                        <h2>{title}</h2>
                        <h4>{subtitle || "Popular this month"}</h4>
                        <p>{description}</p>

                        {link && (
                            <div className="button-row">
                                <a href={link} target="_blank" rel="noreferrer">
                                    Open
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            );
        });
    }

    render() {
        if (this.state.loading) {
            return (
                <div className="loading-screen">
                    <div className="scanner"></div>
                    <h1>Loading...</h1>
                </div>
            );
        }

        if (this.state.error) {
            return (
                <div className="loading-screen">
                    <h1>Transmission failed</h1>
                    <p>{this.state.error}</p>
                </div>
            );
        }

        const month = new Date().toLocaleString('default', { month: 'long' })
        return (
            <div className="cosmos">
                {this.state.hasEasterEggBeenClicked && <FruityPebblesOverlay />}
                <div className="noise"></div>
                <div className="sun"></div>

                <aside className="side-nav">
                    <div className="mark" style={{cursor: "pointer"}} onClick={() => this.setState({hasEasterEggBeenClicked: !this.state.hasEasterEggBeenClicked})}>:)</div>

                    <button
                        className={this.state.mode === "books" ? "active" : ""}
                        onClick={this.setMode.bind(this, "books")}
                    >
                        Books
                    </button>

                    <button
                        className={this.state.mode === "movies" ? "active" : ""}
                        onClick={this.setMode.bind(this, "movies")}
                    >
                        Movies
                    </button>
                    <button
                        className={this.state.mode === "shows" ? "active" : ""}
                        onClick={this.setMode.bind(this, "shows")}
                    >
                        Shows
                    </button>
                    <button className={this.state.mode === "podcasts" ? "active" : ""} onClick={this.setMode.bind(this, "podcasts")}>Podcasts</button>
                    <button className={this.state.mode === "recipes" ? "active" : ""} onClick={this.setMode.bind(this, "recipes")}>Recipes</button>
                    <button className={this.state.mode === "crochet" ? "active" : ""} onClick={this.setMode.bind(this, "crochet")}>Crochet</button>
                    <button className={this.state.mode === "music" ? "active" : ""} onClick={this.setMode.bind(this, "music")}>Music</button>
                    <button className={this.state.mode === "concerts" ? "active" : ""} onClick={this.setMode.bind(this, "concerts")}>Concerts</button>

                </aside>

                <main className="experience">
                    <section className="signal-board">
                        <div className="board-header">
                            <h2>
                                {`Top 10 ${
                                    this.state.mode.charAt(0).toUpperCase() + this.state.mode.slice(1)
                                } in ${month}`}
                            </h2>
                        </div>

                        <div className="orbit-grid">
                            {this.state.mode === "books"
                                ? this.renderCards(this.state.books, "BOOK")
                                : this.state.mode === "movies"
                                    ? this.renderCards(this.state.movies, "MOVIE")
                                    : this.state.mode === "shows"
                                        ? this.renderCards(this.state.shows, "SHOW")
                                        : this.state.mode === "podcasts"
                                            ? this.renderCards(this.state.podcasts, "PODCAST")
                                            : this.state.mode === "recipes"
                                                ? this.renderCards(this.state.recipes, "RECIPE")
                                                : this.state.mode === "crochet"
                                                    ? this.renderCards(this.state.crochet, "CROCHET")
                                                    : this.state.mode === "concerts"
                                                        ? this.renderCards(this.state.concerts, "CONCERTS")
                                                        : this.renderCards(this.state.music, "MUSIC")}
                        </div>
                    </section>
                </main>
            </div>
        );
    }
}

export default App;